import Cleave from 'cleave.js'
import Vue from 'vue'

const hasProperBinding = (binding) => {
  return Object.keys(binding.value).length > 0
}

export default Vue.directive('cleave', {
  bind (el, binding) {
    if (hasProperBinding(binding)) {
      el._vCleave = new Cleave(el, binding.value)
    }
  },

  update (el, binding) {
    if (el._vCleave) {
      el._vCleave.destroy()
    }

    if (hasProperBinding(binding)) {
      el._vCleave = new Cleave(el, binding.value)
    }
  },

  unbind (el) {
    if (el._vCleave) {
      el._vCleave.destroy()
    }
  }
})
